
import style from '../../Style/Components/secondary.module.scss';

const SecondaryButton = (props) => {

    return(
        <button className={`${style.secondary_button}`} 
            type={props.type || 'submit'}
            
            onClick={() => props.handleClick()}
           >
            {props.label}
        </button>
    ); 
} 

export default SecondaryButton;